import { backendPatch } from "@accredo/fe-shared/services/dataService.js";
import { useSnackbar } from "notistack";
import { useCallback } from "react";

export function useReminderActions() {
  const { enqueueSnackbar } = useSnackbar();

  const toggleReminderDone = useCallback(
    async (reminder, done) => {
      const kommunikation = reminder?.kommunikation;
      if (!kommunikation?.id || !kommunikation?.schaden_id) {
        enqueueSnackbar("Erinnerung kann nicht aktualisiert werden", {
          variant: "error",
        });
        return null;
      }

      return await backendPatch(
        `data/kommunikations/${kommunikation.schaden_id}/${kommunikation.id}/reminder`,
        {
          label: "Erinnerung aktualisieren",
          toSend: {
            ist_erledigt: done,
            faellig_am: reminder.faellig_am,
          },
          enqueueSnackbar,
        }
      );
    },
    [enqueueSnackbar]
  );

  return {
    toggleReminderDone,
  };
}
